var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBidIconss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 18,
    viewBox: "0 0 43 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1094 5.85926L9.375 4.12488C9.84375 3.74988 10.5 3.79676 10.9687 4.21863C11.2031 4.45301 11.3438 4.78113 11.3438 5.10926C11.3438 5.34363 11.25 5.62488 11.1094 5.85926Z",
    stroke: "#524E4E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6249 8.48437L2.57803 14.9063C2.10928 15.375 1.35928 15.375 0.890526 14.9063C0.421776 14.4375 0.374901 13.6406 0.843651 13.1719L6.89053 6.75L8.6249 8.48437Z",
    stroke: "#524E4E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9062 6.65625L9.42188 9.28125L6.09375 5.90625L8.57812 3.32812L11.9062 6.65625Z",
    stroke: "#524E4E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96875 6.1875C4.73438 5.95312 4.73438 5.57812 4.96875 5.34375L7.96875 2.15625C8.20312 1.92188 8.625 1.92188 8.85937 2.15625C9.09375 2.39062 9.09375 2.76563 8.85937 3L5.85937 6.1875C5.625 6.42187 5.20312 6.42187 4.96875 6.1875Z",
    stroke: "#524E4E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14062 10.4531C8.90625 10.2188 8.90625 9.84375 9.14062 9.60937L12.1406 6.42188C12.375 6.1875 12.7969 6.1875 13.0312 6.42188C13.2656 6.65625 13.2656 7.03125 13.0312 7.26563L10.0312 10.4063C9.79687 10.6875 9.42188 10.6875 9.14062 10.4531Z",
    stroke: "#524E4E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1094 16.0312H6.89063C6.70313 16.0312 6.51562 15.8438 6.51562 15.6563V15.0469C6.51562 14.8594 6.70313 14.6719 6.89063 14.6719H14.1094C14.2969 14.6719 14.4844 14.8594 14.4844 15.0469V15.6563C14.4844 15.8438 14.3438 16.0312 14.1094 16.0312Z",
    stroke: "#524E4E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7812 14.6719H7.26562V13.7344C7.26562 13.5 7.45312 13.3125 7.6875 13.3125H13.3594C13.5938 13.3125 13.7812 13.5 13.7812 13.7344V14.6719Z",
    stroke: "#524E4E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.936 13.5V5.04H22.644C23.564 5.04 24.272 5.236 24.768 5.628C25.264 6.012 25.512 6.548 25.512 7.236C25.512 7.748 25.36 8.18 25.056 8.532C24.752 8.884 24.332 9.12 23.796 9.24V9.06C24.412 9.148 24.888 9.372 25.224 9.732C25.568 10.084 25.74 10.552 25.74 11.136C25.74 11.888 25.48 12.472 24.96 12.888C24.44 13.296 23.716 13.5 22.788 13.5H18.936ZM20.424 12.324H22.608C23.128 12.324 23.532 12.228 23.82 12.036C24.108 11.836 24.252 11.512 24.252 11.064C24.252 10.608 24.108 10.284 23.82 10.092C23.532 9.892 23.128 9.792 22.608 9.792H20.424V12.324ZM20.424 8.628H22.38C22.932 8.628 23.34 8.528 23.604 8.328C23.876 8.12 24.012 7.816 24.012 7.416C24.012 7.016 23.876 6.716 23.604 6.516C23.34 6.308 22.932 6.204 22.38 6.204H20.424V8.628ZM27.9412 13.5V5.04H29.4892V13.5H27.9412ZM32.0713 13.5V5.04H35.1433C36.1113 5.04 36.9273 5.208 37.5913 5.544C38.2633 5.872 38.7713 6.352 39.1153 6.984C39.4593 7.608 39.6313 8.368 39.6313 9.264C39.6313 10.152 39.4593 10.912 39.1153 11.544C38.7713 12.176 38.2633 12.66 37.5913 12.996C36.9273 13.332 36.1113 13.5 35.1433 13.5H32.0713ZM33.6193 12.216H35.0473C36.0713 12.216 36.8313 11.972 37.3273 11.484C37.8233 10.996 38.0713 10.256 38.0713 9.264C38.0713 8.264 37.8233 7.524 37.3273 7.044C36.8313 6.556 36.0713 6.312 35.0473 6.312H33.6193V12.216Z",
    fill: "#524E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBidIconss);
export default __webpack_public_path__ + "static/media/BidIconss.b36b447c29edfd1e72e9590001ecc4c0.svg";
export { ForwardRef as ReactComponent };